import { Injectable } from '@angular/core';
import { Observable, map, catchError, mergeMap, reduce } from 'rxjs';
import { VehicleGroupRepository } from 'planning-portal-library/src/lib/core/repositories/vehicle-group.repository';
import { BaseResponse } from '../../shared/base.response';
import { HttpClient } from '@angular/common/http';
import { VehicleGroupWebEntity } from './entities/vehicle-group-web-entity';
import { VehicleGroupApiUrls } from './vehicle-group-api-url';
import { vehicleGroupWebRepositoryMapper } from './entities/vehicle-group-web-entity-mapper';
import { VehicleGroup, VehicleType } from 'planning-portal-library/src/lib/core/domain';
import { VehicleGroupDto } from 'planning-portal-library/src/lib/core/domain/requests/vehicle-group/create-edit-vehicle-group-request';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { VehicleTypeWebEntity } from './entities/vehicle-type-web-entity';
import { VehicleTypeWebRepositoryMapper } from './entities/vehicle-type-web-repository-mapper';

@Injectable()
export class VehicleGroupWebRepository extends VehicleGroupRepository {
  private readonly vehicleGroupMapper = new vehicleGroupWebRepositoryMapper();
  private readonly vehicleTypeWebRepositoryMapper = new VehicleTypeWebRepositoryMapper();
    private readonly environment = injectEnvironment();

  constructor(private http: HttpClient,) {
    super();
  }

  getVehicleGroups(planId: string): Observable<VehicleGroupDto[]> {
    return this.http
      .get<BaseResponse<VehicleGroupWebEntity[]>>(
        `${this.environment.url}${VehicleGroupApiUrls.GetvehicleGroup}`,
        {
          params: {
            planId: planId,
          },
        }
      )
      .pipe(
              mergeMap(
                (response: BaseResponse<VehicleGroupWebEntity[]>) => response.result!
              ),
              catchError((err) => {
                throw err;
              })
            )
            .pipe(map(this.vehicleGroupMapper.mapFrom))
            .pipe(
              reduce(
                (items: VehicleGroup[], item: VehicleGroup) => [...items, item],
                []
              )
            );
  }


  createVehicleGroup(request: VehicleGroupDto[]): Observable<boolean> {
  return this.http
    .post<BaseResponse<boolean>>(
      `${this.environment.url}${VehicleGroupApiUrls.CreateVehicleGroup}`,
      request
    )
    .pipe(
      map((response: BaseResponse<boolean>) => response.result ?? false),
      catchError((err) => {
        throw err;
      })
    );
}

  updateVehicleGroup(request: VehicleGroupDto[]): Observable<boolean> {
  return this.http
    .post<BaseResponse<boolean>>(
      `${this.environment.url}${VehicleGroupApiUrls.UpdatevehicleGroup}`,
      request
    )
    .pipe(
      map((response: BaseResponse<boolean>) => response.result ?? false),
      catchError((err) => {
        throw err;
      })
    );
}

    deleteVehicleGroup(id: string): Observable<boolean> {
    return this.http
      .post<BaseResponse<boolean>>(
        `${this.environment.url}${VehicleGroupApiUrls.DeleteVehicleGroup}?id=${id}`,
        null 
      )
      .pipe(
        map((response: BaseResponse<boolean>) => response.result ?? false),
        catchError((err) => {
          throw err;
        })
      );
  }
  getVehicleTypes(): Observable<VehicleType[]> {
    return this.http
      .get<BaseResponse<VehicleTypeWebEntity[]>>(
        `${this.environment.url}${VehicleGroupApiUrls.GetVehicleTypes}`
      )
      .pipe(
              mergeMap(
                (response: BaseResponse<VehicleTypeWebEntity[]>) => response.result!
              ),
              catchError((err) => {
                throw err;
              })
            )
            .pipe(map(this.vehicleTypeWebRepositoryMapper.mapFrom))
            .pipe(
              reduce(
                (items: VehicleType[], item: VehicleType) => [...items, item],
                []
              )
            );
  }

}  